import * as React from 'react';
import {Select, type SingleSelectProps} from '../select';
import type {SelectValue} from '../_select-internals';
import type {ReactNode} from 'react';

type CreatableSelectProps<
  T = unknown,
  V extends SelectValue = string,
  L extends ReactNode = string,
> = Omit<SingleSelectProps<T, V, L>, 'isCreatable' | 'isMulti'>;

const CreatableSelect = React.forwardRef(function CreatableSelect<
  T = unknown,
  V extends SelectValue = string,
  L extends ReactNode = string,
>(props: CreatableSelectProps<T, V, L>, ref: React.Ref<HTMLDivElement>) {
  return <Select ref={ref} {...(props as SingleSelectProps<T, V, L>)} isCreatable />;
}) as <T = unknown, V extends SelectValue = string, L extends ReactNode = string>(
  props: CreatableSelectProps<T, V, L> & {ref?: React.Ref<HTMLDivElement>},
) => React.ReactElement;

export {CreatableSelect};
export type {CreatableSelectProps};
